import React from "react";

export default function AboutMeBlurb() {
  return (
    <>
      <p>
        Hi my name is Emily Wirtz! I am from Kansas City, Missouri. I have a
        B.A. in Spanish and Hispanic Studies, with a minor in Business
        Administration from Creighton University. I just completed my
        certificate for Full Stack Web Development through the University of
        Kansas.
      </p>
      <p>
        I am a Software Engineer based in Kansas City, but open to relocating. I
        enjoy problem solving and critical thinking, and learning to code has
        been an enormous exercise in using both to piece a new language
        together. I love that there will always be somethng new to learn, and
        different ways to make existing languages do innovative things. My
        strengths for now are React.js, JavaScript, and CSS. I'm also working on
        honing my skills using HTML, jQuery, MongoDB, Sequelize, OOP, and the
        MERN stack.
      </p>
      <p>
        Before I started my journey into coding, I worked my way through the
        food service industry. Hosting, serving, and ultimately managing gave me
        the skills to interact with all sorts of people, prioritize and
        re-prioritize many moving parts at once, and take responsibility for my
        work. Another significant work experience was tackling Operations at a
        fine jewelry e-commerce company in San Francisco. There, I worked my way
        up from associate to manager, learning the ins and outs of shipping and
        receiving and operations as a whole. Aside from maintaining the ability
        to keep up with the rapidly rising volume, it was a pleasure to be able
        to work through operational issues and ideas overall and with our
        NetSuite team, creatively solving problems and brainstorming company
        goals.
      </p>
      <p>
        My experiences have allowed me to travel quite a bit, having lived in
        Omaha, San Francisco, and Costa Rica. I also spent a month completing a
        500-mile pilgrimage across Spain known as the Camino de Santiago. Now
        that I've completed my Web Development Certificate, I can't wait to see
        where coding will take me next.
      </p>
      <p>
        <em>Please feel free to reach out, I would love to hear from you!</em>
      </p>
      <p>Email: ewirtz3@gmail.com</p>
    </>
  );
}
